import React, { Suspense } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';

function LoadWidget() {
  return React.lazy(() => import(`./AdCube.js`));
}

export default class Cube extends React.Component {
  componentDidMount() {
    this.AdCubeComponent = LoadWidget();
  }

  render() {
    const AdCube = this.AdCubeComponent;

    if (!AdCube) {
      return null;
    }

    return (
      <ErrorBoundary>
        <Suspense fallback={<div />}>
          <AdCube {...this.props} />
        </Suspense>
      </ErrorBoundary>
    );
  }
}
